export enum FatcaCrsDeclarationType {
  MAIN = 'main',
  SUPPLEMENTARY = 'supplementary'
}

export enum FatcaCrsDeclarationStatus {
  DRAFT = 'draft',
  SIGNED = 'signed',
  PDF_PENDING = 'pdf_pending',
  COMPLETED = 'completed',
  REVOKED = 'revoked'
}

/**
 * Immutable form-version identifier stamped on every signed declaration.
 * Bump this constant whenever any condition/consent/confirmation TEXT changes —
 * old signers must re-declare because their content hash covers the version id.
 */
export const FATCA_CRS_FORM_VERSION = 'fatca-crs-v1' as const;

// The 6 FATCA Annex-II / CRS Part VIII exemption conditions
export enum FatcaCrsCondition {
  REAL_ESTATE_TRANSACTION = 'real_estate_transaction',
  FUNDED_BY_DEPOSIT = 'funded_by_deposit',
  SECURES_OBLIGATION = 'secures_obligation',
  ASSETS_PAID_TO_PARTIES = 'assets_paid_to_parties',
  NOT_MARGIN_ACCOUNT = 'not_margin_account',
  NOT_CREDIT_CARD_LINKED = 'not_credit_card_linked'
}

// Stable snake_case keys for the consent fields stored in declarationValues.
// Renaming any key requires a FATCA_CRS_FORM_VERSION bump.
export const FATCA_CRS_CONSENT_KEYS = {
  DISCLOSURE: 'consent_disclosure',
  ACCURACY_UPDATE: 'consent_accuracy_update',
  SIGNATURE: 'consent_signature'
} as const;

// Stable snake_case keys for the supplementary confirmation fields in declarationValues.
export const FATCA_CRS_CONFIRM_KEYS = {
  BENEFICIARIES_UNCHANGED: 'confirm_beneficiaries_unchanged',
  UPDATE_COMMITMENT: 'confirm_update_commitment',
  SIGNATURE: 'confirm_signature'
} as const;

export enum SupplementaryRevocationReason {
  SELLER_DETAILS = 'seller_details',
  MAIN_DECLARATION = 'main_declaration'
}
